import { QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";

import { queryClient } from "@/app/providers/queryClient";
import { ThemeProvider } from "@/app/providers/ThemeProvider";
import { AuthProvider } from "@/features/auth/state/useAuth";

type Props = {
    children: ReactNode;
};

export const AppProviders = ({ children }: Props) => (
    <ThemeProvider>
        <AuthProvider>
            <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </AuthProvider>
    </ThemeProvider>
);

